<template>
    <!-- 渲染模板
         @author: liuguisheng
         @date: 2019-11-25
    -->
    <!-- :class="{wrap:(wrap||false)}" -->
  <div class="render-item_template" >
    <component :is="renderType"
               :formNode="formNode"
               :class="{[`id-${formNode.id}`]:true}"></component>
  </div>
</template>


<script>
/** 混入方法 ::: 
 *  @mixin mixRenderItemTemplate 预览表单子级混入
 */
import { mixRenderItemTemplate } from "@/mixins/render_item/mix_render_item_template.js";


export default {
  name: "RenderItemTemplate",
  mixins: [ mixRenderItemTemplate ],
  props: {
    formNode: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/render_item/RenderItemTemplate.vue